(function () {
'use strict';

angular
    .module('homeRoutes', [
        'homeControllers',
        'services.historyCtxt'
    ])
    .config(router);

router.$inject = ['$stateProvider', '$urlRouterProvider', 'historyCtxtServiceProvider'];

function router($stateProvider, $urlRouterProvider, historyCtxtServiceProvider) {
    $urlRouterProvider
        .when('', function () { // ie9 fix
            return '/';
        })

        // Survey default
        .when('/', function () {
            var surveyDomainRegex = /survey/;
            var href = window.location.href;

            if (surveyDomainRegex.test(href)) {
                return '/Survey/Available';
            }

            return false;
        });

    $stateProvider.state('root', {
        url: '/',
        controller: 'RootController',
        template: ''
    });

    $stateProvider.state('home', {
        url: '/Employee/',
        sendToGovNew: true
        // url: '/User@{UserItemPersonID}?q&h&r&n&withHighlighting',
        // params: {
        //     h: { array: true },
        //     r: { array: true }
        // },
        // reloadOnSearch: false,
        // controller: 'HomeController',
        // templateUrl: require('./home.tpl.html')

    });

    $stateProvider.state('newHome', {
        url: '/Employee/?openSpotlight',
        sendToGovNew: true
    });

    $stateProvider.state('newBIAProfileSearch', {
        url: '/Search/BIAProfile',
        sendToGovNew: true
    });

    $stateProvider.state('newPlanInitiativeSearch', {
        url: '/Search/PlanInitiative?facets',
        sendToGovNew: true
    });

    $stateProvider.state('newProcedureSearch', {
        url: '/Search/Procedure',
        sendToGovNew: true
    });

    $stateProvider.state('newRecomSearch', {
        url: '/Search/Recommendation?facets',
        sendToGovNew: true
    });

    $stateProvider.state('newInformationSecurityMandateSearch', {
        url: '/Search/InformationSecurityMandates/Mandate?facets',
        sendToGovNew: true
    });

    $stateProvider.state('newInformationSecurityProviderSearch', {
        url: '/Search/InformationSecurityProvider/Provider?facets',
        sendToGovNew: true
    });

    $stateProvider.state('newGovernanceDerogationSearch', {
        url: '/Search/GovernanceDerogation/Derogation?facets',
        sendToGovNew: true
    });

    $stateProvider.state('newGovernanceMandateSearch', {
        url: '/Search/GovernanceMandate/Mandate?facets',
        sendToGovNew: true
    });

    $stateProvider.state('advancedSearch', {
        url: '/Search?q&h&r&p&n&sf&sourceType&withHighlighting',
        params: {
            h: { array: true },
            r: { array: true },
            sf:{ array: true }
        },
        reloadOnSearch: false,
        controller: 'HomeWithSolrController',
        template: 'homeWithSolr.tpl.html'
    });


    historyCtxtServiceProvider.setCtxtState('home',
        '/app/Main/home/GOVHistoryCtxtDirective-searchResults.tpl.html'
    );

    historyCtxtServiceProvider.setCtxtState('advancedSearch',
        '/app/Main/home/GOVHistoryCtxtDirective-searchResults.tpl.html'
    );

}
})();
